import { render, staticRenderFns } from "./manageScript.vue?vue&type=template&id=08725b1a&scoped=true&"
import script from "./manageScript.vue?vue&type=script&lang=js&"
export * from "./manageScript.vue?vue&type=script&lang=js&"
import style0 from "./manageScript.vue?vue&type=style&index=0&id=08725b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08725b1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDialog,VIcon,VSimpleTable})
